export default __webpack_public_path__ + "static/market-leader-db5bef310817288b7372f70e12313639.png";